'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Addpage(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M893.44 339.456c-1.472-6.08-3.968-11.968-8.768-16.704L635.008 73.088C626.432 64.512 614.656 61.952 603.648 64L192 64C121.344 64 64 121.344 64 192l0 704c0 70.656 57.344 128 128 128l576 0c70.656 0 128-57.344 128-128L896 352C896 347.52 895.04 343.296 893.44 339.456zM640 177.92 782.08 320 640 320 640 177.92zM832 896c0 35.392-28.608 64-64 64L192 960c-35.392 0-64-28.608-64-64L128 192c0-35.392 28.608-64 64-64l384 0 0 224C576 369.664 590.336 384 608 384L832 384 832 896zM512 416C512 398.336 497.664 384 480 384S448 398.336 448 416L448 576 288 576C270.336 576 256 590.336 256 608S270.336 640 288 640L448 640l0 160C448 817.664 462.336 832 480 832S512 817.664 512 800L512 640l160 0c17.664 0 32-14.336 32-32S689.664 576 672 576L512 576 512 416z' })
  );
}
Addpage.displayName = 'Addpage';

module.exports = Addpage;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/addpage.js
// module id = 140
// module chunks = 0